import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';

import * as constants from '../config/constants';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Account } from 'app/models/Account';
import { User } from '../models/Users';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { UserSplendid } from 'app/models/UsersSplendid';

@Injectable()
export class SplendidCRMDFService {

    private userProfile$ = new BehaviorSubject<User>(new User());
    private userProfile: User;

    private accounts$ = new BehaviorSubject<Account[]>([]);
    private accounts:Account[];
    private isLogued:boolean = false;
    constructor(
        private _http: Http
    ) { }

    setIsLogued(isLogued){
        this.isLogued = isLogued;
    }

    getIsLogued(){
        return this.isLogued;
    }
    
    setUserProfile(profile: User) {
        //console.log("Ser userProfile" + JSON.stringify(profile));
        this.userProfile = profile;
        this.refresh();
    }

    getUserProfile() {
        return this.userProfile$.asObservable();
    }

    refresh() {
        //console.log(this.userProfile);
        this.userProfile$.next(this.userProfile);
        //console.log("refresh");
    }

    setAccouts(accounts:Account[]) {
        this.accounts = accounts;
        this.accounts$.next(this.accounts);
    }

    getAccounts() {
        return this.accounts$.asObservable();
    }

    queryAccounts(params?: URLSearchParams) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        //headers.append('Accept', 'application/json, text/plain, */*');
        //headers.append('Access-Control-Allow-Origion', '*');

        let options = new RequestOptions({ headers: headers, withCredentials: true });
        return this._http
            .get(constants.SPLENDID_INSTANCE_URL + 'GetModuleList?ModuleName=Accounts', options)
            .map(response => {
                let results = response.json();
                //console.log(results);
                return results.d.results.map((account) => {
                    return Account.fromJson(account);
                })
            }).catch(this.handleError);
    }

    queryUsers(params?: URLSearchParams) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        //headers.append('Accept', 'application/json, text/plain, */*');
        //headers.append('Access-Control-Allow-Origion', '*');

        let options = new RequestOptions({ headers: headers, withCredentials: true });
        return this._http
            .get(constants.SPLENDID_INSTANCE_URL + 'GetModuleList?ModuleName=Users&$orderby=USER_NAME', options)
            .map(response => {
                let results = response.json();
                //console.log(results);
                return results.d.results.map((user) => {
                    return UserSplendid.fromJson(user);
                })
            });
    }

    getProfile() {
        let headers = new Headers();
        headers.append('Accept', 'application/json, text/plain, */*');
        return this._http
            .post(constants.SPLENDID_INSTANCE_URL + 'GetUserProfile', {}, { headers, withCredentials: true })
            // .map((response) => {
            //     var result: any = response.json();
            //     console.log(result);
            //     let profile: User = User.fromJson(result);
            //     //console.log(profile);
            //     return profile;
            // })
            // .catch(this.handleError);
    }


    private handleError(error: any) {
        console.log("Error " + JSON.stringify(error));
        let errMsg = (error.json().error.message) ? error.json().error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return Observable.throw(errMsg);
    };



}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/services/SplendidCRMDFService.ts